import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Box, Button, Dialog, Heading, Spinner } from '@chakra-ui/react';
import { useToast } from '@src/components/chakra-ui/use-toast';
import { gql } from '@src/lib/gql';
import { useRef } from 'react';
type CommentDeleterProps = {
  commentId: string;
  isOpen: boolean;
  onClose: () => any;
};
export const CommentDeleter = props => {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CommentDeleter.mutations.deleteComment();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [deleteComment, deleteCommentMutation] = useMutation(t0);
  const toast = useToast();
  const cancelRef = useRef(null);
  const onClose = props.onClose || _temp;
  let t1;
  if ($[1] !== deleteComment || $[2] !== onClose || $[3] !== props.commentId || $[4] !== toast) {
    t1 = async () => {
      await deleteComment({
        variables: {
          input: {
            commentId: props.commentId
          }
        }
      });
      toast({
        title: "The comment has been deleted.",
        isClosable: true,
        status: "info",
        containerStyle: {
          color: "black"
        }
      });
      onClose();
    };
    $[1] = deleteComment;
    $[2] = onClose;
    $[3] = props.commentId;
    $[4] = toast;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onDelete = t1;
  let t2;
  if ($[6] !== onClose) {
    t2 = e => {
      if (!e.open) {
        onClose();
      }
    };
    $[6] = onClose;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dialog.Backdrop />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Heading fontSize="18px">Are you sure?</Heading>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onClose) {
    t5 = <Button ref={cancelRef} onClick={onClose}>Cancel</Button>;
    $[10] = onClose;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== deleteCommentMutation.loading) {
    t6 = deleteCommentMutation.loading ? <Spinner /> : "Yes, Delete";
    $[12] = deleteCommentMutation.loading;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onDelete || $[15] !== t6) {
    t7 = <Button autoFocus={true} bgColor="red.600" ml={3} onClick={onDelete}>{t6}</Button>;
    $[14] = onDelete;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container" padding="2em" textAlign="center"><Dialog.Body>{t4}<Box marginTop="2em">{t5}{t7}</Box></Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props.isOpen || $[21] !== t2 || $[22] !== t8) {
    t9 = <Dialog.Root open={props.isOpen} onOpenChange={t2}>{t3}{t8}</Dialog.Root>;
    $[20] = props.isOpen;
    $[21] = t2;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
CommentDeleter.mutations = {
  deleteComment: () => gql`
    mutation ($input: DeleteCommentInput!) {
      deleteComment(input: $input) {
        comment {
          id
          thread {
            id
            commentsCount
            commentsAndRepliesCount
          }
          parentComment {
            id
            childCommentsCount
            childComments {
              id
            }
          }
          deletedAt
        }
      }
    }
  `
};
function _temp() {
  return null;
}